var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniverse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 3.37256V4.68216C23.7974 5.93701 23.009 6.99696 21.9272 7.57183C21.3633 7.87952 20.715 8.05252 20.0285 8.05252C17.8725 8.05252 16.1117 6.36296 16.0033 4.23321V3.8204C16.0208 3.51709 16.0679 3.22364 16.1479 2.94113C16.622 1.245 18.1801 0 20.0285 0C22.029 0 23.689 1.45743 24 3.37146V3.37256Z",
    fill: "#2EADD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8948 14.1481C23.8948 14.5313 23.8773 14.9113 23.84 15.2836V15.2869C23.3987 19.9668 20.2627 23.8628 16.0021 25.4078C14.7287 25.8666 13.3544 26.1206 11.9222 26.1206C10.49 26.1206 9.22744 25.8896 8.00106 25.4626C3.65287 23.9613 0.445659 20.026 0 15.2847V4.02821C0.00109499 1.8032 1.80235 0.00195312 4.02626 0.00195312C5.84941 0.00195312 7.39006 1.2141 7.88171 2.8741C7.93646 3.04382 7.97588 3.21793 8.00106 3.39531V13.2228C8.00106 13.8229 7.70541 18.1743 11.9222 18.1743C13.9873 18.1743 15.6944 16.6151 15.9222 14.608V14.6003C15.9408 14.4525 16.0207 13.121 16.0678 12.937C16.5233 11.1719 18.0596 9.89515 19.9627 9.89515C21.6763 9.89515 23.8948 11.4621 23.8948 14.1492V14.1481Z",
    fill: "#DA1A5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniverse);
export default __webpack_public_path__ + "static/media/universe.7a88be8da48e49768b9a89bd3b2b5bf0.svg";
export { ForwardRef as ReactComponent };